import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  filtersContainer: {
    padding: theme.spacing(2),
  },
  filtersHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    cursor: 'pointer',
    padding: theme.spacing(1, 0),
  },
  filterRow: {
    marginBottom: theme.spacing(2),
  },
  filterActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1),
  },
  actionButton: {
    marginLeft: theme.spacing(1),
  },
  situacaoTrigger: {
    display: 'flex',
    cursor: 'pointer',
    border: 'none',
    borderBottom: `1px solid ${theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.42)'}`,
    borderRadius: 0,
    padding: theme.spacing(1.5, 0),
    paddingRight: theme.spacing(4),
    minHeight: 32,
    marginTop: theme.spacing(2),
    backgroundColor: 'transparent',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 400,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      borderBottomColor: theme.palette.text.primary,
    },
    '&:focus': {
      backgroundColor: 'transparent',
      borderBottom: `2px solid ${theme.palette.primary.main}`,
      outline: 'none',
    },
  },
  situacaoTriggerContent: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
    flex: 1,
    minHeight: 24,
    alignItems: 'center',
  },
  situacaoPlaceholder: {
    color: theme.palette.text.secondary,
    fontWeight: 400,
    fontStyle: 'italic',
    textTransform: 'none',
  },
  situacaoChip: {
    fontWeight: 400,
    textTransform: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiChip-label': {
      fontWeight: 400,
      textTransform: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      lineHeight: 1.43,
    },
  },
  situacaoDropdownIcon: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    color: theme.palette.action.active,
    pointerEvents: 'none',
  },
  clienteClearButton: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0.5),
  },
}));
